import type { TranslationCatalog } from "../TranslationManager";

export const ja: TranslationCatalog = {
  "labels.cardNumber": "カード番号",
  "labels.expirationDate": "有効期限",
  "labels.cvc": "セキュリティコード",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "MM / YY",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "カード番号が無効です。",
  "errors.invalidExpiryDate": "カードの有効期限が無効です。",
  "errors.invalidCvc": "カードのセキュリティコードが無効です。",
  "errors.incompleteCardNumber": "カード番号が不完全です。",
  "errors.incompleteExpiryDate": "カードの有効期限が不完全です。",
  "errors.incompleteCvc": "カードのセキュリティコードが不完全です。",
  "errors.expiredCard": "カードの有効期限が切れています。",
  "aria.cardNumber": "カード番号",
  "aria.expirationDate": "有効期限",
  "aria.cvc": "セキュリティコード",
  "aria.cardInput": "カード情報",
};
